import React, {Fragment, useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from '@s7ui-kit/s7ui-kit';
import {connect} from 'react-redux';
import classNames from 'classnames';
import Cookie from 'js-cookie'; 
import pushGA from '../../../services/utils/pushGA';
import pushGA4 from '../../../services/utils/pushGA4';
import pushYM from '../../../services/utils/pushYM';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import {Declension} from '../../../services/services/Declension';
import format from 'date-fns/format';
import isSameDay from 'date-fns/is_same_day';
import changePrepositionForm from '../../../services/utils/changePrepositionForm';
import requestUtil from "../../../services/services/requestUtil";
import RecommendationsCards from "../RecommendationsCards";
import { CDN_PATH } from '../../../constants/variables';

import dateLocales from '@s7ui-kit/portal-forms/build/dateLocales';
import {AIRPLANES} from '../../../services/constants/airplanes';

import Hotel from './images/Hotels.svg';
import Automobile from './images/Automobile.svg';
import Plane from './images/plane.svg';
import ChevronRight from './images/ChevronRight.svg';
import Chevron from './images/Chevron.svg';
import BriefcaseNo from './images/BriefcaseNo.svg';
import SeatEconomy from './images/SeatEconomy.svg';
import Silverware from './images/Silverware.svg';
import Extra from './images/icon-extra-space.svg';
import Upgrade from './images/Upgrade.svg';
import S7 from './images/S7.svg';

import styles from './next-flight.css';

const mapStateToProps = ({App, User}) => ({App, User});

const MYB_DOMAIN = process.env.REACT_APP_MYB_DOMAIN;

const mobileBreakpoint = 768;
const tabletBreakpoint = 1024;

const recommendationServices = [
    {
        name:'upgrade',
        desktop: 'com.s7.next.trip.recomend.desktop.upgrade',
        mobile: 'com.s7.next.trip.recomend.mobile.upgrade',
        icon: <Upgrade/>,
        ga: 'upgrade',
        target: 'upgrades'
    },
    {
        name: 'prepaid_baggage',
        desktop: 'com.s7.next.trip.recomend.desktop.baggage',
        mobile: 'com.s7.next.trip.recomend.mobile.baggage',
        icon: <BriefcaseNo/>,
        ga: 'xbag',
        target: 'bags'
    },
    {
        name: 'meal',
        desktop: 'com.s7.next.trip.recomend.desktop.meal',
        mobile: 'com.s7.next.trip.recomend.mobile.meal',
        icon: <Silverware/>,
        ga: 'meal',
        target: 'meals'
    },
    {
        name: 'prereserved_seat',
        desktop: 'com.s7.next.trip.recomend.desktop.seat',
        mobile: 'com.s7.next.trip.recomend.mobile.seat',
        icon: <SeatEconomy/>,
        ga: 'seats',
        target: 'seats'
    },
    {
        name: 'extra_space',
        desktop: 'com.s7.next.trip.recomend.desktop.extra',
        mobile: 'com.s7.next.trip.recomend.mobile.extra',
        icon: <Extra/>,
        ga: 'extra',
        target: 'seats'
    }
];

const NextFlight = props => {
    const {App: {deviceWidth, lang}} = props;
    const {User: { profile, nextFlight }} = props;
    const { showTitle, showRecomendations, getTrip, words, getMessage } = props;
    const declension = new Declension(words, getMessage);

    const [ trip, setTrip ] = useState({});
    const [ wciLink, setWciLink ] = useState('');
    const fromProfile = useRef(false);

    useEffect(() => {
        if(!nextFlight || isEmpty(nextFlight)){
            setTrip({});
            return;
        }

        if(nextFlight && isEmpty(nextFlight.trip)){
            setTrip({});
            return false;
        }

        const commonTrip = nextFlight.trip;
        fromProfile.current = commonTrip.fromProfile;
        if(!commonTrip.orders || isEmpty(commonTrip.orders) || !commonTrip.orders[0].airs ){
            return false;
        }
        const airTrip = commonTrip.orders[0].airs[0];
        const passenger = getPassengerLastName(airTrip.passengers);

        let trip = {};
        trip.segment = getSegment(airTrip);

        if(!trip.segment) {
            return false;
        }

        if(Array.isArray(commonTrip.orders) && !isEmpty(commonTrip.orders)) {
            trip.cars = getCars(commonTrip.orders[0].cars);
            trip.hotels = !isEmpty(commonTrip.orders[0].hotels);
            trip.spnr = commonTrip.orders[0].spnr;
        }
        trip.imageUrl = commonTrip.imageUrl ? getImage(commonTrip.imageUrl.replace(/\s+/g,'')) : 'S7PCabinService/media/by-path/crop/330x300/images/s7_default.jpg';
        trip.date = getTripsDate(airTrip.tripType, airTrip.startDate, airTrip.endDate);
        trip.passenger = passenger;
        getWCIUrl(airTrip.pnr, passenger);
        //trip.wciUrl = getWCIUrl(airTrip.pnr, passenger);
        trip.mybUrl = getMYBUrl(airTrip.pnr, passenger);
        trip.pnr = airTrip.pnr;
        trip.destinationName = commonTrip.locationName;
        trip.destinationIata = commonTrip.destination;

        trip.checkinOpen = checkIn(trip.segment.departureDate, trip.segment.departureDateUTC);
        trip.segment.departureFormatTime = getTime(trip.segment.departureDate);
        trip.segment.arrivalFormatTime = getTime(trip.segment.arrivalDate);
        trip.segment.daysToFlight = daysToFlight(trip.segment.departureDateUTC);

        if (trip.segment.duration && trip.segment.duration.amount) {
            trip.segment.duration.hours = Math.floor(trip.segment.duration.amount / 60);
            trip.segment.duration.minutes = trip.segment.duration.amount % 60;
        }

        trip.segment.arrivalAirport.name = trip.segment.arrivalLocation;
        trip.segment.departureAirport.name = trip.segment.departureLocation;

        let aircraft = trip.segment.aircraftDescription;
        if (!aircraft) {
            aircraft = AIRPLANES[trip.segment.aircraftCode] ? AIRPLANES[trip.segment.aircraftCode].name : '';
        }

        trip.aircraftDescription = aircraft;

        trip.segment.airline = getAirline(trip.segment.marketingAirline, trip.segment.operatingAirline, trip.segment.partnerAirlineName);

        trip.recommendations = [];

        if (nextFlight?.recommendation && !isEmpty(nextFlight.recommendation)){
            trip.recommendations = getRecomendation(nextFlight.recommendation);
        }

        pushGA(
            'PORTAL NextTrip',
            'Show',
            `CHECKIN:${trip.checkinOpen};ORDERID:${trip.spnr};PNR:${trip.pnr}`,
            {
                flightDetail: `FROM:${trip.segment.departureAirport.code};TO:${trip.segment.arrivalAirport.code};LEFT:${trip.segment.daysToFlight}`,
                eventValue: trip.recommendations ? trip.recommendations.length  : 0,
                eventInteraction: 1,
                eventUX: undefined
            }
        );

        pushGA4(
            'load_success',
            'myb',
            'next_trip',
            {
                wci_info: `checkin:${trip.checkinOpen === 'open'}`,
                item_name: 'next_trip_widget',
                pnr: trip.pnr,
                result: 'load_widget',
                step: 'trips'
            }
        );
        pushYM({
            goalParams: {
                event_name: 'load_success',
                application: 'myb',
                wci_info: `checkin:${trip.checkinOpen === 'open'}`,
                item_name: 'next_trip_widget',
                flow: 'next_trip',
                pnr: trip.pnr,
                result: 'load_widget',
                step: 'trips',
            }
        });

        setTrip(trip);

        // pushGA4(
        //     'event_error',
        //     'myb',
        //     'next_trip',
        //     {
        //         step: 'trips',
        //         error: 'load_success',
        //         item_name: JSON.stringify(error),
        //         type: 'service'
        //     }
        // )
        // pushYM({
        //     ymID: getYandexID(),
        //     eventName: 'event_error',
        //     goalParams: {
        //         event_name: 'event_error',
        //         application: 'myb',
        //         flow: 'next_trip',
        //         step: 'trips',
        //         error: 'load_success',
        //         item_name: error,
        //         type: 'service',
        //         user_id: Cookie.get('profileId') || undefined
        //     }
        // });
    }, [ nextFlight ]);

    useEffect(() => {
        getTrip(trip);
    }, [trip]);

    const getImage = imageUrl => {
        const image = imageUrl.replace('https://','');
        return `${CDN_PATH}S7WImageResizeService/resize/330/300/${image}`;
    };

    const getSegment = trip => {
        if(!trip || !Array.isArray(trip.routes) || isEmpty(trip.routes)) return;

        if(fromProfile.current) {
            const firstSegmentsArray = trip.routes[0].segments;
            let allSegments = firstSegmentsArray;
            if (trip.routes[1]) {
                const secondSegmentsArray = trip.routes[1].segments;
                allSegments = firstSegmentsArray.concat(secondSegmentsArray);
            }

            if (!allSegments || !Array.isArray(allSegments) || isEmpty(allSegments)) return;

            const filteredSegments = allSegments.filter(segment => {
                if (!segment.departureDateUTC) {
                    return false;
                }
                const isFuture = Date.parse(`${segment.departureDateUTC}.000+0000`) - Date.now() > 0;
                return (segment.status === "CONFIRMED" || segment.status === "PENDING" || segment.status === "UNDETERMINED") && isFuture;
            });

            if (!filteredSegments || !Array.isArray(filteredSegments) || isEmpty(filteredSegments)) return;

            const sortedSegment = sortBy(filteredSegments, segment => {
                return Date.parse(segment.departureDateUTC);
            });

            return sortedSegment[0];
        } else {
            if(!trip.routes[0].segments || !Array.isArray(trip.routes[0].segments) || isEmpty(trip.routes[0].segments)) return;
                return trip.routes[0].segments[0];
            }
    };

    const getAirline = (marketing, operating, partner) => {
        let airline = {};

        if(marketing && marketing.code && marketing.flightNumber){
            airline.flight = `${marketing.code} ${marketing.flightNumber}`;
        }

        if (operating && operating.code && (operating.code.toLowerCase() === 's7' || operating.code.toLowerCase() === 'gh')){
            airline.name = `S7 Airlines`;
            airline.logo = <S7/>;
        } else if(partner) {
            airline.name = partner;
        }

        return airline;
    };

    const getMYBUrl = (pnr, passenger, target) => {
        const locale = !['en', 'ru'].includes(lang) ? 'en': lang;

        if(!fromProfile.current) {
            return `${MYB_DOMAIN}find-order?locale=${locale}&myb_medium=s7PortalNextTrip`;
        }

        const searchParams = new URLSearchParams();

        searchParams.append('request_locale', locale);
        searchParams.append('surname', passenger);
        searchParams.append('superPnrId', pnr);
        searchParams.append('serviceType', 'myb');
        searchParams.append('wci_medium', 's7PortalProfile');
        searchParams.append('myb_medium', 's7PortalNextTrip');

        if (target) {
            searchParams.append('target_product', target);
        }

        return process.env.NODE_ENV !== 'development' ?
            `/external/s7-apps-redirect.dot?${searchParams.toString()}` :
            `http://qa-www.s7.ru/external/s7-apps-redirect.dot?${searchParams.toString()}`;
    };

    const getUrlParamsWCIService = (isMYBWCIService, pnr, passenger) => {
        const locale = !['en', 'ru'].includes(lang) ? 'en': lang;
        const searchParams = new URLSearchParams();

        if (isMYBWCIService) {
            searchParams.append('serviceType', 'wci');
            searchParams.append('surname', passenger);
            searchParams.append('number', pnr);
        } else {
            searchParams.append('request_locale', locale);
            searchParams.append('surname', passenger);
            searchParams.append('number', pnr);
            searchParams.append('identificationMethod', 'pnr');
            searchParams.append('serviceType', 'wci');
            searchParams.append('wci_medium', 's7PortalProfile');
            searchParams.append('_action', 'login');
        }

        /*return*/ setWciLink(process.env.NODE_ENV !== 'development' ?
            `/external/s7-apps-redirect.dot?${searchParams.toString()}` :
            `http://qa-www.s7.ru/external/s7-apps-redirect.dot?${searchParams.toString()}`);
    };

    const getWCIUrl = (pnr, passenger) => {
        const locale = !['en', 'ru'].includes(lang) ? 'en': lang;

        if(!fromProfile.current) {
            setWciLink(`${MYB_DOMAIN}find-order?locale=${locale}&myb_medium=s7PortalNextTrip`);
            return ;
        }

        let isMYBWCIService = false;

        if(typeof(s7PageInit)!=='undefined' && s7PageInit.botConfig && s7PageInit.botConfig.MYBWCIService) {
            isMYBWCIService = s7PageInit.botConfig.MYBWCIService === "NONE";
            getUrlParamsWCIService(isMYBWCIService, pnr, passenger);
        } else {
            const searchParams = new URLSearchParams('');
            searchParams.append('lang', lang);
            searchParams.append('_', toString(new Date().valueOf()));

            requestUtil(`/S7WContentService/api/v1/bot/locks?${searchParams}`)
                .then(data => {
                    if(data && data.MYBWCIService) {
                        isMYBWCIService = data.MYBWCIService === "NONE";
                        getUrlParamsWCIService(isMYBWCIService, pnr, passenger);
                    } else {
                        getUrlParamsWCIService(isMYBWCIService, pnr, passenger);
                    }
                });

        }
    };

    const getRecomendation = recommendations => {
        if(!recommendations || !Array.isArray(recommendations)) {
            return false;
        }

        const filterRecommendations = recommendations.map(recommendation => {
            const recommendItem = recommendationServices.find(item => item.name.toLowerCase() === recommendation.emd.toLowerCase());

            if(!recommendItem){
                return false;
            }
            return recommendItem;
        });

        return filterRecommendations.filter(recommentaion => recommentaion);
    };

    const getTitle = () => {
        if(isEmpty(profile) || !profile.names || profile.names && !Array.isArray(profile.names)) {
            return getMessage(words, 'com.s7.next.trip.title.upper');
        }
        const name = profile.names.find(name => {
            const langId = lang !== 'ru'? 'en' : lang;
            return name.lang === langId;
        });
        if(!name || !name.firstName) {
            return getMessage(words, 'com.s7.next.trip.title.upper');
        }

        return `${name.firstName},&nbsp;${getMessage(words, 'com.s7.next.trip.title')}`;
    };

    const getCurrentUTC = () => {
        const currentDate = new Date().toISOString().replace('Z', '');
        return Date.parse(currentDate);
    };

    const checkIn = (departureDate, departureDateWithTimeZone) => {
        if (!departureDate || !departureDateWithTimeZone){
            return false;
        }

        //проверка, если время до вылета меньше 30 часов
        const departureDateUTC = Date.parse(departureDateWithTimeZone);
        const diffDates = departureDateUTC - getCurrentUTC();

        return diffDates < 108000000 ? 'open' : 'closed';
    };

    const getTime = date => {
        if(!date) {
            return false;
        }
        const dateArray = date.split('T');

        if(!dateArray || dateArray && !dateArray[1]) {
            return false;
        }

        return dateArray[1].slice(0, 5);
    };

    const daysToFlight = departure => {
        if(!departure){
            return false;
        }

        const departureDateUTC = Date.parse(departure);
        const diffDates = departureDateUTC - getCurrentUTC();

        return diffDates > 0 ? Math.floor(diffDates/86400000) : 0;
    };

    const getTripsDate = (type, start, end) => {
        if(!type || !start || !end){
            return false;
        }

        const startDateFormat = getFormattedDate(start);

        if(type === "ONE_WAY" || isSameDay(new Date(start), new Date(end))) {
            return startDateFormat;
        };

        const endDateFormat = getFormattedDate(end);

        if(!startDateFormat || !endDateFormat) return false;
        return `${startDateFormat} — ${endDateFormat}`;
    };

    const getFormattedDate = date => {
        if(!date){
            return false;
        };

        const dateFormat = format(new Date(date), 'dd, DD MMM',  {
            locale: dateLocales[lang]
        });

        if(!dateFormat){
            return false;
        };

        return dateFormat.replace(/\./g, '').toLowerCase();
    };

    const getPassengerLastName = passengers => {
        if (!passengers || !Array.isArray(passengers)){
            return false;
        }

        const passenger = passengers[0];

        if(!passenger || !passenger.names || !Array.isArray(passenger.names) || isEmpty(passenger.names)|| !passenger.names[0].lastName){
            return false;
        }

        return passenger ? passenger.names[0].lastName.toLowerCase() : false;
    };

    const getCars = cars => {
       if(isEmpty(cars) || !Array.isArray(cars) || isEmpty(cars[0])) {
           return false;
       }
       return cars[0].status && ['INITIAL', 'BOOKED', 'COMPLETED', 'PENDING'].includes(cars[0].status);
    };

    const renderRecommendation = recomendations => {
        if(!recomendations || isEmpty(recomendations)){
            return false;
        }
        let i = 0;
        const limit = deviceWidth < mobileBreakpoint ? 3 : 4;

        return map(recomendations, (recomendation, key) => {
            if(recomendation && (i < limit) && recomendation.mobile && recomendation.desktop && recomendation.icon){
                i++;
                return (<a
                    href={getMYBUrl(trip.pnr, trip.passenger, recomendation.target)}
                    className={styles.detailProduct}
                    onClick={()=>{gaRecomendation(recomendation.ga)}}>
                    <div className={classNames({
                        [styles.detailProductIcon]: true,
                    })}>
                        <span className={styles.detailProductAdd}>+</span>
                        {recomendation.icon}
                    </div>
                    <div className={classNames({
                        [styles.detailProductText]: true,
                    })}>
                        {deviceWidth < mobileBreakpoint ? getMessage(words, recomendation.mobile): getMessage(words, recomendation.desktop)}
                    </div>
                </a>)
            }
            return false;
        });
    };

    const gaRecomendation = recomendation => {
        pushGA(
            'PORTAL NextTrip',
            'Click_AddAncillary',
            `CHECKIN:${trip.checkinOpen};ORDERID:${trip.spnr};PNR:${trip.pnr};PRODUCT:${recomendation}`,
            {
                flightDetail: `FROM:${trip.segment.departureAirport ? trip.segment.departureAirport.code : ''};TO:${trip.segment.arrivalAirport? trip.segment.arrivalAirport.code: ''};LEFT:${trip.segment.daysToFlight}`,
                eventValue: undefined,
                eventInteraction: 0,
                eventUX: undefined
            }
        );
    };

    const gaDetail = () => {
        pushGA(
            'PORTAL NextTrip',
            'Click_GoToMYB',
            `CHECKIN:${trip.checkinOpen};ORDERID:${trip.spnr};PNR:${trip.pnr}`,
            {
                flightDetail: `FROM:${trip.segment.departureAirport ? trip.segment.departureAirport.code : ''};TO:${trip.segment.arrivalAirport? trip.segment.arrivalAirport.code: ''};LEFT:${trip.segment.daysToFlight}`,
                eventValue: undefined,
                eventInteraction: 0,
                eventUX: undefined
            }
        );
    };

    const gaCheckIn = () => {
        pushGA(
            'PORTAL NextTrip',
            'Click_GoToWCI',
            `CHECKIN:open;ORDERID:${trip.spnr};PNR:${trip.pnr}`,
            {
                flightDetail: `FROM:${trip.segment.departureAirport ? trip.segment.departureAirport.code : ''};TO:${trip.segment.arrivalAirport? trip.segment.arrivalAirport.code: ''};LEFT:${trip.segment.daysToFlight}`,
                eventValue: undefined,
                eventInteraction: 0,
                eventUX: undefined
            }
        );
    };

    return (
        (!isEmpty(trip) && trip.segment) &&
        <Fragment>
            {showTitle && <p
                className={'mainpage-holder-next_trip-title'}
                dangerouslySetInnerHTML={{
                    __html: getTitle()
                }}/>}
            <div className={classNames({
                [styles.block]: true,
                [styles.blockWithRecommendation]: !isEmpty(trip.recommendations),
            })}
            >
                {(deviceWidth > tabletBreakpoint) &&
                <a className={styles.blockLink} href={trip.mybUrl} onClick={() => gaDetail()}>
                    <div
                        className={classNames({
                            [styles.common]: true,
                            [styles.commonWithRecommendation]: !isEmpty(trip.recommendations),
                        })}
                        style={trip.imageUrl ? {backgroundImage: `url(${trip.imageUrl})`} : null}>
                        <div className={styles.commonBg}></div>
                        <div className={styles.commonInfo}>
                            {trip.destinationName &&
                            <p className={styles.commonDirection}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: getMessage(words, 'com.s7.next.trip.travel.to')
                                    }}/>
                                {changePrepositionForm(getMessage(words, 'com.s7.words.preposition.to'), trip.destinationName)}&nbsp;
                                {declension.toCity({city: trip.destinationName, iata: trip.destinationIata})}
                            </p>}
                            <p className={styles.commonDates}>{trip.date}</p>
                        </div>
                        <div className={styles.commonIcons}>
                            <Plane
                                className={classNames({
                                    [styles.commonIcon]: true,
                                    [styles.commonIconPlane]: true,
                                    [styles.commonIconActive]: true,
                                })}
                            />
                            <Automobile
                                className={classNames({
                                    [styles.commonIcon]: true,
                                    [styles.commonIconCar]: true,
                                    [styles.commonIconActive]: trip.cars,
                                })}
                            />
                            <Hotel
                                className={classNames({
                                    [styles.commonIcon]: true,
                                    [styles.commonIconHotel]: true,
                                    [styles.commonIconActive]: trip.hotels,
                                })}
                            />
                        </div>
                    </div>
                </a>}
                {(deviceWidth < mobileBreakpoint) &&
                <a
                    href={trip.mybUrl}
                    className={styles.commonMobileMore}
                    onClick={() => gaDetail()}
                >
                    <div className={styles.commonMobile}>
                        <div className={styles.commonMobileInfo}>
                            {trip.segment.airline && trip.segment.airline.logo &&
                            <span className={styles.commonMobileAirlineLogo}>{trip.segment.airline.logo}</span>}
                            {trip.segment.airline && trip.segment.airline.flight &&
                            <p className={styles.commonMobileFlightNumber}>{trip.segment.airline.flight}</p>}
                        </div>

                        <ChevronRight/>

                    </div>
                </a>
                }
                <div className={styles.detail}>
                    {(deviceWidth >= mobileBreakpoint) && <div className={styles.detailCheckIn}>
                        {trip.checkinOpen === 'open' ?
                            <a
                                href={wciLink}
                                className={styles.detailCheckInBtn}
                                onClick={() => gaCheckIn()}
                            >
                                {getMessage(words, 'com.s7.next.trip.chekin.avialiable.desktop')}</a> :
                            <p className={styles.detailCheckInText}
                               dangerouslySetInnerHTML={{__html: getMessage(words, 'com.s7.next.trip.chekin.unavialiable')}}/>
                        }
                        <a
                            href={trip.mybUrl}
                            onClick={() => gaDetail()}
                            className={styles.detailCheckInLink}
                        >
                            <span
                                className={styles.detailCheckInLinkText}>{getMessage(words, 'com.s7.next.trip.detail')}</span>
                            <span className={styles.detailCheckInLinkIcon}>
                                <Chevron/>
                            </span>
                        </a>
                    </div>}
                    <div className={styles.detailInfo}>
                        {(deviceWidth >= mobileBreakpoint) && <div className={styles.detailFlight}>
                            {trip.segment.airline && trip.segment.airline.name &&
                            <p className={styles.detailFlightCompany}>{trip.segment.airline.name}</p>}
                            {trip.segment.airline && trip.segment.airline.flight &&
                            <p className={styles.detailFlightNumber}>{trip.segment.airline.flight}</p>}
                            {trip.aircraftDescription &&
                            <p className={styles.detailFlightModel}>{trip.aircraftDescription}</p>}
                        </div>}
                        <div className={styles.detailDirections}>
                            <div className={styles.detailDate}>
                                {trip.segment.departureDate &&
                                <p className={styles.detailFromDate}>{getFormattedDate(trip.segment.departureDate)}</p>}
                                {trip.segment.arrivalDate &&
                                <p className={styles.detailToDate}>{getFormattedDate(trip.segment.arrivalDate)}</p>}
                            </div>

                            <div className={styles.detailTime}>
                                {trip.segment.departureFormatTime &&
                                <p className={styles.detailFromTime}>{trip.segment.departureFormatTime}</p>}
                                <p className={styles.detailCommonTime}>
                                    {trip.segment.duration && !!trip.segment.duration.hours && <span
                                        className={styles.detailCommonTimeText}>{trip.segment.duration.hours}{getMessage(words, 'com.timetable.hour')}&nbsp;{!!trip.segment.duration.minutes && `${trip.segment.duration.minutes}${getMessage(words, 'com.timetable.minute')} `}
                                        {(deviceWidth >= mobileBreakpoint) && getMessage(words, 'com.s7.next.trip.duration')}</span>}
                                </p>
                                {trip.segment.arrivalFormatTime &&
                                <p className={styles.detailToTime}>{trip.segment.arrivalFormatTime}</p>}
                            </div>
                            <div className={styles.detailAirports}>
                                {trip.segment.departureAirport && <div className={styles.detailFromAirport}>
                                    {trip.segment.departureAirport.name && <p>{trip.segment.departureAirport.name}</p>}
                                    <p>
                                        {trip.segment.departureAirport.code &&
                                        <span>{trip.segment.departureAirport.code}</span>}
                                        {trip.segment.legs && Array.isArray(trip.segment.legs) && !isEmpty(trip.segment.legs) && trip.segment.legs[0].departureAirport &&
                                        <span>
                                            {trip.segment.legs[0].departureAirport.terminal ? `, ${getMessage(words, 'com.s7.next.trip.terminal')} ${trip.segment.legs[0].departureAirport.terminal}` : ''}
                                        </span>}
                                    </p>
                                </div>}
                                {trip.segment.arrivalAirport && <div className={styles.detailToAirport}>
                                    {trip.segment.arrivalAirport.name && <p>{trip.segment.arrivalAirport.name}</p>}
                                    <p>
                                        {trip.segment.arrivalAirport.code &&
                                        <span>{trip.segment.arrivalAirport.code}</span>}
                                        {trip.segment.legs && Array.isArray(trip.segment.legs) && !isEmpty(trip.segment.legs) && trip.segment.legs[0].arrivalAirport &&
                                        <span>
                                            {trip.segment.legs[0].arrivalAirport.terminal ? `, ${getMessage(words, 'com.s7.next.trip.terminal')} ${trip.segment.legs[0].arrivalAirport.terminal}` : ''}
                                        </span>}
                                    </p>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {!isEmpty(trip.recommendations) && <div className={styles.detailProducts}>
                        {renderRecommendation(trip.recommendations)}
                    </div>}
                    {(deviceWidth < mobileBreakpoint) && <div
                        className={classNames({
                            [styles.detailMobileCheckIn]: true,
                            [styles.detailMobileCheckInOpen]: trip.checkinOpen === 'open',
                        })}
                    >
                        {trip.checkinOpen === 'open' ?
                            <a
                                href={wciLink}
                                onClick={() => gaCheckIn()}
                                className={styles.detailMobileCheckInBtn}
                            >
                                {getMessage(words, 'com.s7.next.trip.chekin.avialiable.mobile')}
                            </a> :
                            <p className={styles.detailMobileCheckInText}
                               dangerouslySetInnerHTML={{__html: getMessage(words, 'com.s7.next.trip.chekin.unavialiable')}}/>
                        }
                    </div>}
                </div>
            </div>
            {
                lang === 'ru' && showRecomendations &&
                <RecommendationsCards limit={3} trip={trip} />
            }
        </Fragment>
    );
};

NextFlight.propTypes = {
    showTitle: PropTypes.bool,
    showRecomendations: PropTypes.bool,
    getTrip: PropTypes.func
};

NextFlight.defaultProps = {
    showTitle: true,
    showRecomendations: true,
    getTrip: () => {}
};

export default injectIntl(connect(mapStateToProps)(React.memo(NextFlight)));
